module.exports = __webpack_public_path__ + "img/MEDIA031.8dbdbc1a.jpg";